var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.9953,51.377c-.9623-2.069,3.4028-6.2239,6.017-12.0822,1.1268-2.5251,1.2295-4.7069.738-6.384-1.2826-2.5697-2.3564-3.62-3.4174-6.1225-.8441-1.991,8.174-.2897,8.3927-.3765.8853-.7861,3.2644-9.554,5.4268-12.2402.9874-1.2266,3.396-2.6415,5.7808-2.5013,2.0182.1187,4.1012,1.3013,4.9603,2.3747,2.171,2.7125,4.7139,12.2063,5.4308,12.3544,1.9302.3988,7.9684-1.8974,8.321.4119.0771.5053-1.9201,5.7746-2.2439,6.1147-.5692,1.348-1.1653,3.3725-.3164,5.4799,1.2135,3.0123,6.055,8.5856,6.0544,14.0239,0,.1925-.9263,5.5194-7.6907,3.6474-.1511-.0418-.184-.1383-.2678-.2018-1.5408-1.1691-4.7131-1.7748-7.61-.9184-3.4167,1.01-2.8112,2.9781-6.954,4.7235-1.0835.4565-3.1113,1.2832-5.7731,1.0496-.7152-.0628-2.7788-.2675-4.8115-1.6059-2.9156-1.9198-2.3607-3.9289-4.7879-5.7011-3.2153-2.3478-6.5523-.5481-7.2491-2.0461Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8979,
    cy: 23.2122,
    rx: 1.7074,
    ry: 3.1872,
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5193,
    cy: 30.3411,
    rx: 1.7742,
    ry: 2.1254,
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    d: "m40.1212,56.6767c.7152-.0627,3.5205-2.5204,5.4482-2.3674,3.4799.2761,9.0034,3.463,11.4306,1.6907,3.2152-2.3476,1.2678-3.0961,1.9646-4.5942.9623-2.069-3.4028-6.2239-6.017-12.0822-1.1268-2.5251-1.2295-4.7069-.738-6.384,1.2826-2.5697,2.3564-3.62,3.4174-6.1225.8441-1.991-8.174-.2897-8.3927-.3765-.8853-.7861-1.9246-3.9216-3.4483-7.7112"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1007,
    cy: 23.2122,
    rx: 1.7074,
    ry: 3.1872,
    fill: "#3f3f3f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8778,
    cy: 23.2122,
    rx: 1.7074,
    ry: 3.1872,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m13.9753,51.377c-.9623-2.069,3.4028-6.2239,6.017-12.0822,1.1268-2.5251,1.2295-4.7069.738-6.384-1.2826-2.5697-2.3564-3.62-3.4174-6.1225-.8441-1.991,8.174-.2897,8.3927-.3765.8853-.7861,3.2644-9.554,5.4268-12.2402.9874-1.2266,3.396-2.6415,5.7808-2.5013,2.0182.1187,4.1012,1.3013,4.9603,2.3747,2.171,2.7125,4.7139,12.2063,5.4308,12.3544,1.9302.3988,7.9684-1.8974,8.321.4119.0771.5053-1.9201,5.7746-2.2439,6.1147-.5692,1.348-1.1653,3.3725-.3164,5.4799,1.2135,3.0123,6.055,8.5856,6.0544,14.0239,0,.1925-.9263,5.5194-7.6907,3.6474-.1511-.0418-4.9809-1.9766-7.8778-1.1202-3.4167,1.01-2.8112,2.9781-6.954,4.7235-1.0835.4565-3.1113,1.2832-5.7731,1.0496-.7152-.0628-2.7788-.2675-4.8115-1.6059-2.9156-1.9198-2.3607-3.9289-4.7879-5.7011-3.2154-2.3478-6.5524-.5481-7.2491-2.0461Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.4993,
    cy: 30.3411,
    rx: 1.7742,
    ry: 2.1254,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0806,
    cy: 23.2122,
    rx: 1.7074,
    ry: 3.1872,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.b7b80126b604c05b141bfe3b158865b1.svg";
export { ForwardRef as ReactComponent };